import { prefix } from "../../design-tokens/meta";
import { actions } from "../../js/state-machine/index";
import { events } from "../../js/state-machine";
import { matchers } from "../../js/validate-props";
import { positions } from "../../js/positioning";

export const componentName = "Tooltip";
export const showTooltipDelay = 500;
export const maxContentWidth = 220;

export const eventMap = Object.freeze({
    [actions.show().type]: events.show(componentName),
    [actions.hide().type]: events.hide(componentName),
});

export const defaultProps = Object.freeze({
    placement: positions.top,
});

export const schema = Object.freeze({
    placement: matchers.or(
        matchers.includes(["top", "right", "bottom", "left"]),
        matchers.match(/(left|right|top|bottom)-(start|end)/gi)
    ),
});

export const componentClasses = Object.freeze({
    tooltip: `${prefix}tooltip`,
    tooltipMaxContent: `${prefix}tooltip--max-content`,
    show: `${prefix}tooltip--show`,
    body: `${prefix}tooltip__body`,
    title: `${prefix}tooltip__title`,
    animating: `${prefix}tooltip--animating`,
    dismiss: `${prefix}tooltip__dismiss`,
    pointer: `${prefix}tooltip__pointer`,
});

export const views = Object.freeze({
    show: {
        classList: [`${componentClasses.show}`],
    },
    hide: {
        classList: [`!${componentClasses.show}`],
    },
    beforeAnimation: {
        classList: [`${componentClasses.animating}`],
    },
    afterAnimation: {
        classList: [`!${componentClasses.animating}`],
    },
    maxContent: {
        classList: [`${componentClasses.tooltipMaxContent}`],
    },
});
